export default __webpack_public_path__ + "3843f232519108bb7a2e85af3c84207b.png";